module.exports = __webpack_public_path__ + "static/media/user_empty.d4a34bb7c8836891252751f058fc09a3.svg";